import {
  DocumentClassAttributes,
  OrderAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { ActionApplicationEnum } from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/action-application.enum";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { DocumentClassAction } from "app/common/interfaces/documentClassAction.interface";

export function validateOrdersByAction(
  orders: OrderAttributes[],
  documentClassesList: DocumentClassAttributes[],
  action: string
) {
  const documentClassAction: DocumentClassAction[] = [];
  for (let dc of documentClassesList) {
    //Filtro accion
    let syncAction = dc?.actionsRequirements.find((ar) => ar.action == action);
    //Filtro los que son para WEB
    if (
      syncAction &&
      syncAction.applications?.includes(ActionApplicationEnum.WEB)
    ) {
      documentClassAction.push({
        code: dc.code,
        name: dc.name,
        action: syncAction,
      });
    }
  }

  let flagGeneral = true;

  let flagDocumentClass: boolean = false;
  let flagStatus: boolean = false;
  let flagStatusERP: boolean = false;
  let flagTrip: boolean = false;
  let flagExtenalTrip: boolean = false;
  let flagExternalTransaction: boolean = false;

  for (let order of orders) {
    if (
      order?.type?.code == DocumentTypeEnum.DOCUMENTO_DE_CARGA &&
      action == "SYNC"
    ) {
      // Si la orden es de tipo documento de carga y la acción es SYNC, no se valida
      flagGeneral = true;
      continue;
    }

    let documentClassToValidate = documentClassAction.find(
      (dca) => dca.code == order?.class?.code
    );

    //Validacion clase de documento
    if (documentClassToValidate !== undefined) {
      flagDocumentClass = true;
    } else {
      flagGeneral = false;
      break;
    }

    //Validacion de status
    //if(documentClassToValidate.action.statusIds && documentClassToValidate.action.statusIds.find(as => as === order.statusId) !== undefined){
    if (
      (documentClassToValidate.action.statusIds &&
        documentClassToValidate.action.statusIds.length == 0) ||
      documentClassToValidate.action.statusIds.includes(order.statusId)
    ) {
      flagStatus = true;
    }

    //Validacion de statusERP
    if (
      (documentClassToValidate.action.statusERPIds &&
        documentClassToValidate.action.statusERPIds.length == 0) ||
      documentClassToValidate.action.statusERPIds.includes(order.statusERP)
    ) {
      flagStatusERP = true;
    }

    //Validacion de trip
    flagTrip =
      documentClassToValidate.action.haveTrip === null || //Si validacion de viaje es null, flagTrip => true
      (documentClassToValidate.action.haveTrip === true && !!order?.trip) || //Si validacion de viaje es true y la orden tiene viaje => true
      (documentClassToValidate.action.haveTrip === false && !order?.trip); //Si validacion de viaje es false y la orden no tiene viaje => true

    //Validacion de viaje externo (trip.externalKeys)
    flagExtenalTrip =
      documentClassToValidate.action.haveExternalTrip == null || //Si validacion de viaje externo es null, flagExternalTrip => true
      (documentClassToValidate.action.haveExternalTrip === true &&
        !!order?.trip?.externalKeys?.code) || //Si validacion de viaje externo es true y la orden tiene viaje.externalKeys => true
      (documentClassToValidate.action.haveExternalTrip === false &&
        !order.trip?.externalKeys?.code); //Si la validacion de viaje externo es false y la orden no tiene viaje.externalKeys => true

    //Validacion de codigo externo (externalKeys)
    flagExternalTransaction =
      documentClassToValidate.action.haveExternalTransaction == null || //Si validacion de codigo externo es null, flagExternalTransaction => true
      (documentClassToValidate.action.haveExternalTransaction === true &&
        !!order?.externalKeys?.code) || //Si validacion de codigo externo es true y la orden tiene externalKeys => true
      (documentClassToValidate.action.haveExternalTransaction === false &&
        !order?.externalKeys?.code); //Si validacion de codigo externo es false y la orden no tiene externalKey => true

    //Validación general de la orden
    if (
      flagDocumentClass &&
      flagStatus &&
      flagStatusERP &&
      flagTrip &&
      flagExtenalTrip &&
      flagExternalTransaction
    ) {
      flagGeneral = true;
    } else {
      flagGeneral = false;
      break;
    }
  }

  return flagGeneral;
}

export function validateOrdersByActionForPayment(
  orders: OrderPaymentAttributes[],
  documentClassesList: DocumentClassAttributes[],
  action: string
) {
  const documentClassAction: DocumentClassAction[] = [];
  for (let dc of documentClassesList) {
    //Filtro accion
    let syncAction = dc?.actionsRequirements.find((ar) => ar.action == action);
    //Filtro los que son para WEB
    if (
      syncAction &&
      syncAction.applications?.includes(ActionApplicationEnum.WEB)
    ) {
      documentClassAction.push({
        code: dc.code,
        name: dc.name,
        action: syncAction,
      });
    }
  }

  let flagGeneral = true;

  let flagDocumentClass: boolean = false;
  let flagStatus: boolean = false;
  let flagStatusERP: boolean = false;
  let flagTrip: boolean = false;
  let flagExtenalTrip: boolean = false;
  let flagExternalTransaction: boolean = false;

  for (let order of orders) {
    let documentClassToValidate = documentClassAction.find(
      (dca) => dca.code == order.document_class.code
    );

    //Validacion clase de documento
    if (documentClassToValidate !== undefined) {
      flagDocumentClass = true;
    } else {
      flagGeneral = false;
      break;
    }

    //Validacion de status
    //if(documentClassToValidate.action.statusIds && documentClassToValidate.action.statusIds.find(as => as === order.statusId) !== undefined){
    if (
      (documentClassToValidate.action.statusIds &&
        documentClassToValidate.action.statusIds.length == 0) ||
      documentClassToValidate.action.statusIds.includes(order.paymentReview)
    ) {
      flagStatus = true;
    }

    // Validacion de statusERP
    if (
      (documentClassToValidate.action.statusERPIds &&
        documentClassToValidate.action.statusERPIds.length == 0) ||
      documentClassToValidate.action.statusERPIds.includes(order.paymentStatus)
    ) {
      flagStatusERP = true;
    }

    //Validacion de trip
    flagTrip =
      documentClassToValidate.action.haveTrip === null || //Si validacion de viaje es null, flagTrip => true
      (documentClassToValidate.action.haveTrip === true && !!order?.trip) || //Si validacion de viaje es true y la orden tiene viaje => true
      (documentClassToValidate.action.haveTrip === false && !order?.trip); //Si validacion de viaje es false y la orden no tiene viaje => true

    //Validacion de viaje externo (trip.externalKeys)
    flagExtenalTrip =
      documentClassToValidate.action.haveExternalTrip == null || //Si validacion de viaje externo es null, flagExternalTrip => true
      (documentClassToValidate.action.haveExternalTrip === true &&
        !!order?.trip?.externalKeys?.code) || //Si validacion de viaje externo es true y la orden tiene viaje.externalKeys => true
      (documentClassToValidate.action.haveExternalTrip === false &&
        !order.trip?.externalKeys?.code); //Si la validacion de viaje externo es false y la orden no tiene viaje.externalKeys => true

    //Validacion de codigo externo (externalKeys)
    flagExternalTransaction =
      documentClassToValidate.action.haveExternalTransaction == null || //Si validacion de codigo externo es null, flagExternalTransaction => true
      (documentClassToValidate.action.haveExternalTransaction === true &&
        !!order?.externalKeys?.code) || //Si validacion de codigo externo es true y la orden tiene externalKeys => true
      (documentClassToValidate.action.haveExternalTransaction === false &&
        !order?.externalKeys?.code); //Si validacion de codigo externo es false y la orden no tiene externalKey => true

    //Validación general de la orden
    if (
      flagDocumentClass &&
      flagStatus &&
      flagTrip &&
      flagStatusERP &&
      flagExternalTransaction &&
      flagExtenalTrip
    ) {
      flagGeneral = true;
    } else {
      flagGeneral = false;
      break;
    }
  }
  return flagGeneral;
}

export function validateIsAction(
  orders: OrderAttributes[],
  documentClassesList: DocumentClassAttributes[],
  action: string
) {
  const documentClassAction: DocumentClassAction[] = [];
  for (let dc of documentClassesList) {
    //Filtro accion
    let syncAction = dc?.actionsRequirements.find((ar) => ar.action == action);
    //Filtro los que son para WEB
    if (
      syncAction &&
      syncAction?.applications?.includes(ActionApplicationEnum.WEB)
    ) {
      documentClassAction.push({
        code: dc.code,
        name: dc.name,
        action: syncAction,
      });
    }
  }

  let flagGeneral = true;

  let flagDocumentClass: boolean = false;

  for (let order of orders) {
    if (
      order?.type?.code == DocumentTypeEnum.DOCUMENTO_DE_CARGA &&
      action == "SYNC"
    ) {
      // Si la orden es de tipo documento de carga y la acción es SYNC, no se valida
      flagGeneral = true;
      continue;
    }

    let documentClassToValidate = documentClassAction.find(
      (dca) => dca?.code == order?.class?.code
    );

    //Validacion clase de documento
    if (documentClassToValidate !== undefined) {
      flagDocumentClass = true;
    } else {
      flagGeneral = false;
      break;
    }
  }
  return flagGeneral;
}
